import { useState } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import styles from './marketplace-faq.module.css';

interface MarketplaceFaqItem {
  question: string;
  answer: string;
  open?: boolean;
  onOpenChange?: () => void;
}

const FaqItem = ({ question, answer, open, onOpenChange }: MarketplaceFaqItem) => {
  return (
    <div className={classNames(styles.item, open && styles.open)}>
      <div className={styles.header} onClick={onOpenChange}>
        <div className={styles.name}>{question}</div>
        <ReactSVG src="/icons/chevron-down.svg" className={styles.arrow} />
      </div>
      {open && <div className={styles.content} dangerouslySetInnerHTML={{ __html: answer }} />}
    </div>
  );
};

interface MarketplaceFaqProps {
  items: MarketplaceFaqItem[];
}

const MarketplaceFaq = ({ items }: MarketplaceFaqProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className={styles.root}>
      {items.map(({ question, answer }, index) => (
        <FaqItem
          question={question}
          answer={answer}
          open={openIndex === index}
          onOpenChange={() => setOpenIndex(index)}
          key={question}
        />
      ))}
    </div>
  );
};

export default MarketplaceFaq;
